import styled, { css } from 'styled-components';
import tinycolor from 'tinycolor2';
import { Color } from '../../base';

const LoaderWrapper = styled.div`
  transition: all ease-in-out 0.2s;
  display: inline-block;
  position: relative;
  ${props =>
    props.isLoading
      ? css`
          display: block;
          width: 100%;
          min-height: 25px;
          animation: pulse 0.5s linear infinite alternate;
          overflow: hidden;
          &:after {
            content: ' ';
            top: 0;
            width: 0;
            height: 100%;
            box-shadow: 0 0 40px 5px ${Color.greyDark};
            transform: rotate(20deg);
            position: absolute;
            animation: wipe 1s ease-in-out infinite;
          }

          & * {
            opacity: 0;
          }
        `
      : css`
          background-color: transparent;
        `}
  ${props =>
    props.block &&
    css`
      display: block;
      width: 100%;
    `}

    @keyframes wipe {
    0% {
      left: -60px;
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    75% {
      opacity: 1;
    }
    100% {
      left: calc(100% + 60px);
      opacity: 0;
    }
  }
  @keyframes pulse {
    from {
      background-color: ${({ theme: { colors } }) =>
        tinycolor(colors.gray.primary)
          .setAlpha(0.5)
          .toString()};
    }
    to {
      background-color: transparent;
    }
  }
`;

export { LoaderWrapper };
